module.exports = __webpack_public_path__ + "img/feature-hardware-quick-triggers.9e84027.svg";